export default class PausePopup extends Phaser.GameObjects.Sprite {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser.GameObjects.Sprite
   */
  constructor(scene, popupGroup) {
    let width = scene.cameras.main.width;
    let height = scene.cameras.main.height;
    super(scene, width / 2, height / 2, 'pause_popup');
    this.setDepth(10);
    this.overlay = scene.add.image(0, 0, 'white');
    this.overlay.setOrigin(0, 0);
    this.overlay.setDisplaySize(width, height);
    this.overlay.setDepth(this.depth - 1);
    this.overlay.tint = '#000000';
    this.overlay.alpha = 0;

    this.scene = scene;
    this.paddingX = 100;
    this.paddingY = 230;
    this.setOrigin(0.5);
    this.scaleX = 1.2;
    this.scaleY = 1.2;
    this.alpha = 0;
    this.active = false;
    this.emitter = new Phaser.Events.EventEmitter();

    popupGroup.add(this, true);

    // this.title = scene.add.bitmapText(
    //   scene.cameras.main.width / 2,
    //   scene.cameras.main.height / 2 - 135,
    //   'HelloHeadline',
    //   'Paused'
    // );

    let localisation = scene.cache.json.get('localisation');
    this.title = scene.add.text(scene.cameras.main.width / 2, scene.cameras.main.height / 2 - 155, localisation["pause_title"][window.language].text, {fontFamily: localisation["pause_title"][window.language].font});
    this.title.setFontSize(Number.parseFloat(localisation["pause_title"][window.language].size));
    this.title.setPadding(0,20,0,20);
    let title = this.title;
    title.setOrigin(0.5);
    popupGroup.add(title);
    title.alpha = 0;
    title.setDepth(this.depth + 1);

    this.playBtn = scene.add.sprite(
      scene.cameras.main.width / 2,
      scene.cameras.main.height / 2 + 30,
      'startBtn'
    );
    let playBtn = this.playBtn;
    playBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.handlePlayButtonDown());
    playBtn.alpha = 0;
    popupGroup.add(playBtn);
    playBtn.setDepth(this.depth + 1);

    let muteState = ('sound_' + (this.scene.mute === false ? 'on' : 'off'));
    this.muteBtn = scene.add.sprite(
      scene.cameras.main.width / 2 - this.paddingX,
      scene.cameras.main.height / 2 + this.paddingY,
      muteState
    );
    let muteBtn = this.muteBtn;
    muteBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.handleMuteButtonDown());
    muteBtn.alpha = 0;
    popupGroup.add(muteBtn);
    muteBtn.setDepth(this.depth + 1);

    this.helpBtn = scene.add.sprite(
      scene.cameras.main.width / 2 + this.paddingX,
      scene.cameras.main.height / 2 + this.paddingY,
      'helpBtn'
    );
    let helpBtn = this.helpBtn;
    helpBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.handleHelpButtonDown());
    helpBtn.alpha = 0;
    popupGroup.add(helpBtn);
    helpBtn.setDepth(this.depth + 1);
  }

  show(scene) {
    if (this.btnTween !== undefined) {
      this.btnTween.stop();
      this.btnTween = undefined;
    }
    this.muteBtn.setTexture('sound_' + (this.scene.sound.mute === false ? 'on' : 'off'));
    this.active = true;

    this.scaleX = 1.2;
    this.scaleY = 1.2;

    scene.tweens.add({
      targets: this.overlay,
      alpha: 0.5,
      ease: 'Cubic',
      duration: 150
    });

    this.btnTween = scene.tweens.add({
      targets: [this, this.title, this.playBtn, this.muteBtn, this.helpBtn],
      alpha: 1,
      scaleX: 1,
      scaleY: 1,
      ease: 'Cubic',
      duration: 150,
      // delay: 50,
      onComplete: this.onShown
    });
  }

  onShown() {
    if (this.emitter !== undefined) {
      this.emitter.emit('gamePaused');
    }
  }

  onHidden() { }

  hide(scene) {
    scene.tweens.add({
      targets: this.overlay,
      alpha: 0,
      ease: 'Cubic',
      duration: 150
    });

    if (this.btnTween !== undefined) {
      this.btnTween.stop();
      this.btnTween = undefined;
    }

    scene.tweens.add({
      targets: [this, this.title, this.playBtn, this.muteBtn, this.helpBtn],
      scaleX: 1,
      scaleY: 1,
      alpha: 0,
      ease: 'Cubic',
      duration: 150,
      onComplete: this.onHidden
    });
    this.active = false;
  }

  handlePlayButtonDown() {
    //this.scene.paused = false;
    if (this.emitter !== undefined) {
      this.emitter.emit('gameResumed');
    }
    this.hide(this.scene);
  }

  handleMuteButtonDown() {
    this.scene.toggleMute(!this.scene.mute);
    this.muteBtn.setTexture('sound_' + (this.scene.mute == false ? 'on' : 'off'));
  }

  handleHelpButtonDown() {
    // do something helpy
    this.hide(this.scene);
    this.emitter.emit('helpRequested');
  }

  destroy() {
    if (this.btnTween !== undefined) {
      this.btnTween.stop();
      this.btnTween = null;
    }
    this.overlay.destroy();
    this.title.destroy();
    this.playBtn.destroy();
    this.muteBtn.destroy();
    this.helpBtn.destroy();
    this.emitter.destroy();
    super.destroy();
  }
}
